import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["source", "display", "image", "title", "body", "link"]
    declare readonly titleTarget: HTMLElement
    declare readonly bodyTarget: HTMLElement
    declare readonly imageTarget: HTMLImageElement
    declare readonly linkTarget: HTMLAnchorElement
    declare readonly sourceTargets: HTMLElement[]

    connect() {
        // 1. On page load, grab the first article from the list
        const firstItem = this.sourceTargets[0]

        // 2. If it exists, populate the right-side card immediately
        if (firstItem) {
            this.renderPreview(firstItem.dataset)
            // Optional: Add the gray hover background to the first item by default
            firstItem.style.backgroundColor = "#f0f0f0"
        }
    }

    // This is the method called by 'mouseenter->preview#update'
    update(event:any) {
        // Reset all titles to transparent background first
        this.sourceTargets.forEach(el => el.style.backgroundColor = "transparent")

        // Highlight the current one being hovered
        event.currentTarget.style.backgroundColor = "#f0f0f0"

        // Update the right-side card with data from the hovered element
        this.renderPreview(event.currentTarget.dataset)
    }

    // Reusable function to swap the content
    renderPreview(data:any) {
        this.titleTarget.textContent = data.previewTitleValue
        this.bodyTarget.textContent = data.previewBodyValue
        this.linkTarget.href = data.previewUrlValue

        // Handle the image: show it if it exists, hide if it doesn't
        if (data.previewImageValue && data.previewImageValue !== "") {
            this.imageTarget.src = data.previewImageValue
            this.imageTarget.style.display = "block"
        } else {
            this.imageTarget.style.display = "none"
        }

        // Make the 'Read Full Article' button visible
        this.linkTarget.style.display = "inline-block"
    }
}